/**
 * Site-wide scroll reveal.
 *
 * Safety first: the CSS that hides elements is gated behind the `dom-reveal-on`
 * class, which is only added here. If this file fails to parse or never runs,
 * nothing is ever hidden and the page reads exactly as it would without it.
 *
 * Deliberately NOT using IntersectionObserver. IO silently never fires in some
 * embedded webviews, and TikTok / Instagram in-app browsers are where most of
 * this store's traffic lands. A geometry check over a handful of nodes is
 * cheaper than a bug nobody can reproduce on a desktop.
 */
(() => {
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  if (reduced.matches) return; // leave everything visible, do nothing

  root.classList.add('dom-reveal-on');

  const SHOW_AT = 0.9; // reveal once the top edge is within 90% of the viewport
  let nodes = [];

  const collect = () => {
    nodes = Array.prototype.slice.call(document.querySelectorAll('[data-dom-reveal]'));
  };

  const paint = () => {
    const vh = window.innerHeight;
    for (let i = 0; i < nodes.length; i++) {
      const el = nodes[i];
      if (el.dataset.domRevealed === '1') continue; // reveal once, never re-hide
      const r = el.getBoundingClientRect();
      if (r.top < vh * SHOW_AT && r.bottom > 0) {
        el.dataset.domRevealed = '1';
        el.classList.add('dom-reveal-in');
      }
    }
  };

  // Called straight from the scroll handler. A requestAnimationFrame gate is the
  // usual optimisation, but if rAF is throttled in a webview the "queued" flag
  // latches on and every later scroll is swallowed.
  const refresh = () => { collect(); paint(); };

  addEventListener('scroll', paint, { passive: true });
  addEventListener('resize', paint);
  addEventListener('load', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);

  // Safety net: if anything is still hidden well after load, show it. Better a
  // missed animation than invisible product copy.
  setTimeout(() => {
    nodes.forEach((el) => {
      el.dataset.domRevealed = '1';
      el.classList.add('dom-reveal-in');
    });
  }, 4000);

  refresh();
})();
